import { usePostingWizard } from './usePostingWizard';

export const useStepIdMatch = (stepId: string) => {
  const [state] = usePostingWizard();

  return state.matches(stepId);
};
